/** Semantic category for chart card info tooltip copy (data description + conclusions). */
export enum ChartInfoKind {
    TRANSACTION_VOLUME_LINE = 'transaction-volume-line',
    TRANSACTION_VOLUME_BAR = 'transaction-volume-bar',
    TRANSACTION_VOLUME_BY_STATE_LIST = 'transaction-volume-by-state-list',
    TRANSACTION_VOLUME_BY_SENDER_LIST = 'transaction-volume-by-sender-list',
    TRANSACTION_VOLUME_BY_RECEIVER_LIST = 'transaction-volume-by-receiver-list',
    TRANSACTION_TIMERS_DURATION_BY_USER_DROP_OFF_LIST = 'transaction-timers-duration-by-user-drop-off-list',
    TRANSACTION_TIMERS_DURATION_BY_USER_PICK_UP_LIST = 'transaction-timers-duration-by-user-pick-up-list',
    TRANSACTION_ACTIVE_VOLUME_BAR = 'transaction-active-volume-bar',
    TRANSACTION_DROP_OFF_VOLUME_BAR = 'transaction-drop-off-volume-bar',
    TRANSACTION_PICK_UP_VOLUME_BAR = 'transaction-pick-up-volume-bar',
    TRANSACTION_DROP_OFF_PICK_UP_VOLUME_BAR = 'transaction-drop-off-pick-up-volume-bar',
    TRANSACTION_PURCHASE_ORDER_VOLUME_BAR = 'transaction-purchase-order-volume-bar',
    TRANSACTION_TIMER_WAITING_DAYS_DONUT = 'transaction-timer-waiting-days-donut',
    TRANSACTION_TIMER_WAITING_DAYS_STACKED_BAR = 'transaction-timer-waiting-days-stacked-bar',
    TRANSACTION_TIMER_DURATION_METRIC = 'transaction-timer-duration-metric',
    TRANSACTION_TIMER_ACTIVITY_WEEKDAY_HEATMAP = 'transaction-timer-activity-weekday-heatmap',
    TRANSACTION_TIMER_ACTIVITY_HOUR_DAY_HEATMAP = 'transaction-timer-activity-hour-day-heatmap',
    TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT = 'transaction-volume-by-slot-dimension-donut',
    TRANSACTION_VOLUME_BY_SPOT_DONUT = 'transaction-volume-by-spot-donut',
    DAILY_TURNOVER_RATE_LINE = 'daily-turnover-rate-line',
    STALE_PICK_UP_TRANSACTIONS_LIST = 'stale-pick-up-transactions-list',
    STALE_DROP_OFF_TRANSACTIONS_LIST = 'stale-drop-off-transactions-list',
    SPOT_FILL_RATE_LINE = 'spot-fill-rate-line',
    SPOT_FILL_RATE_METRIC = 'spot-fill-rate-metric',
    VENDING_PACKAGE_VOLUME_LINE = 'vending-package-volume-line',
    VENDING_PACKAGE_VOLUME_BY_PRODUCT_LIST = 'vending-package-volume-by-product-list',
    VENDING_PACKAGE_VOLUME_BY_PRODUCT_MONTHLY_LIST = 'vending-package-volume-by-product-monthly-list',
    VENDING_PACKAGE_VOLUME_BY_USER_LIST = 'vending-package-volume-by-user-list',
    VENDING_PACKAGE_VOLUME_WEEKDAY_HEATMAP = 'vending-package-volume-weekday-heatmap',
    VENDING_PACKAGE_VOLUME_HOUR_BAR = 'vending-package-volume-hour-bar',
    FILL_RATE_BY_PRODUCT_LIST = 'fill-rate-by-product-list',
    FILL_RATE_BY_PRODUCT_LINE = 'fill-rate-by-product-line',
    FILL_RATE_BY_SPOT_LIST = 'fill-rate-by-spot-list',
    FILL_RATE_TOTAL_METRIC = 'fill-rate-total-metric',
    FILL_RATE_STATUS_DONUT = 'fill-rate-status-donut',
    CONSUMPTION_RATE_BY_PRODUCT_LIST = 'consumption-rate-by-product-list',
    PERIOD_CHANGE_METRIC = 'period-change-metric',
    PRODUCTS_NEEDING_REFILL_LIST = 'products-needing-refill-list',
    VENDING_PRODUCT_POPULARITY_LIST = 'vending-product-popularity-list',
    VENDING_TIME_TO_STOCKOUT_LIST = 'vending-time-to-stockout-list',
    VENDING_PACKAGE_TIMERS_DURATION_AUDIT_PENDING_BY_PRODUCT_LIST = 'vending-package-timers-duration-audit-pending-by-product-list',
    LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_LIST = 'lending-outbound-package-volume-by-product-list',
    LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_MONTHLY_LIST = 'lending-outbound-package-volume-by-product-monthly-list',
    LENDING_EQUIPMENT_USES_VOLUME_BY_PRODUCT_LIST = 'lending-equipment-uses-volume-by-product-list',
    LENDING_OUTBOUND_PACKAGE_VOLUME_WEEKDAY_HEATMAP = 'lending-outbound-package-volume-weekday-heatmap',
    LENDING_RETURN_PACKAGE_VOLUME_WEEKDAY_HEATMAP = 'lending-return-package-volume-weekday-heatmap',
    EQUIPMENT_STATE_DONUT = 'equipment-state-donut',
    EQUIPMENT_STATE_LIST = 'equipment-state-list',
    EQUIPMENT_CERTIFICATIONS_DONUT = 'equipment-certifications-donut',
    EQUIPMENT_DURATION_BY_PRODUCT_LIST = 'equipment-duration-by-product-list',
    EQUIPMENT_DURATION_BY_EQUIPMENT_LIST = 'equipment-duration-by-equipment-list',
    LONGEST_IN_USE_EQUIPMENTS_LIST = 'longest-in-use-equipments-list',
    UNAVAILABLE_PRODUCTS_LIST = 'unavailable-products-list',
    IOTS_VOLUME_BY_STATUS_DONUT = 'iots-volume-by-status-donut',
    IOTS_VOLUME_BY_STATUS_BAR = 'iots-volume-by-status-bar',
    IOTS_VOLUME_BY_TYPE_LIST = 'iots-volume-by-type-list',
    IOTS_UPTIME_LINE = 'iots-uptime-line',
    IOTS_UPTIME_METRIC = 'iots-uptime-metric',
    IOTS_UPTIME_BY_TYPE_LIST = 'iots-uptime-by-type-list',
    IOTS_UPTIME_WEEKDAY_HEATMAP = 'iots-uptime-weekday-heatmap',
    CRITICAL_IOTS_LIST = 'critical-iots-list',
    CONSUMPTION_VOLUME_BAR = 'consumption-volume-bar',
    RECYCLES_VOLUME_BAR = 'recycles-volume-bar',
    REPLENISHMENTS_VOLUME_BAR = 'replenishments-volume-bar',
    RETURNS_VOLUME_BAR = 'returns-volume-bar'
}
